export const formatFieldName = name => {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace('epa', 'EPA')
    .replace('iihs', 'IIHS')
    .replace('mpg', 'MPG')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const transformOverviewData = style =>
  [
    { name: 'MSRP', value: style.price?.baseMSRP ? `${style.price.baseMSRP.toLocaleString()}` : 'N/A' },
    { name: 'Body Type', value: style.categories?.PRIMARY_BODY_TYPE?.[0] },
    { name: 'Engine', value: `${style.engineSize}L ${style.engineCylinder}-Cylinder ${style.engineType}` },
    { name: 'Transmission', value: style.transmissionType },
    { name: 'Seating', value: `${style.numberOfSeats} passengers` },
  ].filter(item => item.value);

export const transformPerformanceData = style => {
  const specs = style.attributeGroups?.SPECIFICATIONS?.properties;
  return [
    {
      name: 'Combined Fuel Economy',
      value:
        specs?.EPA_COMBINED_MPGE || specs?.EPA_COMBINED_MPG
          ? `${specs.EPA_COMBINED_MPGE || specs.EPA_COMBINED_MPG} ${specs.EPA_COMBINED_MPGE ? 'MPGe' : 'MPG'}`
          : null,
    },
    {
      name: 'City Fuel Economy',
      value:
        specs?.EPA_CITY_MPGE || specs?.EPA_CITY_MPG
          ? `${specs.EPA_CITY_MPGE || specs.EPA_CITY_MPG} ${specs.EPA_CITY_MPGE ? 'MPGe' : 'MPG'}`
          : null,
    },
    {
      name: 'Highway Fuel Economy',
      value:
        specs?.EPA_HIGHWAY_MPGE || specs?.EPA_HIGHWAY_MPG
          ? `${specs.EPA_HIGHWAY_MPGE || specs.EPA_HIGHWAY_MPG} ${specs.EPA_HIGHWAY_MPGE ? 'MPGe' : 'MPG'}`
          : null,
    },
    {
      name: 'Max Towing',
      value: specs?.TOWING_CAPACITY ? `${parseInt(specs.TOWING_CAPACITY, 10).toLocaleString()} lbs` : null,
    },
    { name: 'Fuel Capacity', value: specs?.FUEL_CAPACITY ? `${specs.FUEL_CAPACITY} gal` : null },
  ].filter(item => item.value);
};

export const transformDimensionsData = style => {
  const exteriorDim = style.attributeGroups?.EXTERIOR_DIMENSIONS?.properties;
  const interiorDim = style.attributeGroups?.INTERIOR_DIMENSIONS?.properties;
  return [
    { name: 'Length', value: exteriorDim?.OVERALL_LENGTH ? `${exteriorDim.OVERALL_LENGTH} in` : null },
    { name: 'Height', value: exteriorDim?.OVERALL_HEIGHT ? `${exteriorDim.OVERALL_HEIGHT} in` : null },
    {
      name: 'Width',
      value: exteriorDim?.OVERALL_WIDTH_WITHOUT_MIRRORS ? `${exteriorDim.OVERALL_WIDTH_WITHOUT_MIRRORS} in` : null,
    },
    { name: 'Wheelbase', value: exteriorDim?.WHEELBASE ? `${exteriorDim.WHEELBASE} in` : null },
    {
      name: 'Front Legroom',
      value: interiorDim?.['1ST_ROW_LEG_ROOM'] ? `${interiorDim['1ST_ROW_LEG_ROOM']} in` : null,
    },
    {
      name: '2nd Row Legroom',
      value: interiorDim?.['2ND_ROW_LEG_ROOM'] ? `${interiorDim['2ND_ROW_LEG_ROOM']} in` : null,
    },
  ].filter(item => item.value);
};

export const transformSafetyData = style => {
  const crashRatings = style.attributeGroups?.CRASH_TEST_RATINGS?.properties;
  return crashRatings
    ? Object.entries(crashRatings)
        .filter(([, value]) => value && value !== 'Not Tested')
        .map(([key, value]) => ({ name: formatFieldName(key), value }))
    : [];
};
